module.exports = __webpack_public_path__ + "media/images/recipes/bonvite_kiprolade-26b3fcc0c84c73bf5c2757e410429605.pdf";